









































import { Component, Emit, Vue, Prop, Ref, Watch } from "vue-property-decorator";

import { ChatEntry } from "@/interfaces/meeting/details";
import { formatDateTime, formatTime } from "@/utils/datetime";

@Component({
  filters: {
    formatTime
  }
})
export default class MyChat extends Vue {
  @Ref() chatElement!: HTMLElement;
  @Ref() messagesElement!: HTMLElement;

  @Prop({ type: Array })
  chatEntries!: ChatEntry[];

  @Prop()
  userId!: string;

  chatText = "";

  mounted() {
    this.$nextTick(function() {
      this.scrollToEnd();
    });
  }

  @Watch("chatEntries")
  onChatEntriesChange(chatEntries: ChatEntry[]) {
    this.$nextTick(function() {
      this.scrollToEnd();
    });
  }

  scrollToEnd() {
    this.messagesElement.scrollTop = this.messagesElement.scrollHeight;
  }

  get chatStartTime() {
    return formatDateTime(this.chatEntries[0]?.when);
  }

  getIsMe(chatEntry: ChatEntry) {
    return chatEntry.user_id === this.userId;
  }

  @Emit()
  sendMessage() {
    const message = this.chatText;
    this.chatText = "";
    return message;
  }
}
